import { folderSchemas } from "@redotech/redo-views-common/folders";
import { viewWithIdSchemas } from "@redotech/redo-views-common/views";
import * as z from "zod";
import { null as zNull } from "zod";
export const saveViewsAndFolders = {
  name: "saveViewsAndFolders" as const,
  input: z.object({
    folders: z.array(folderSchemas["fulfillment-groups"]),
    views: z.array(viewWithIdSchemas["fulfillment-groups"]),
  }),
  output: zNull(),
};
